
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { UserListInterface } from '../models/interfaces/user-list.model';
import { UserModel } from '../models/interfaces/user.model';
import { CerrixDialogService } from '../services/cerrix-dialog.service';
import { UserAvatarComponent } from '../../atoms/user-avatar/user-avatar.component';

@Component({
    selector: 'cerrix-selectable-user-list',
    imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    UserAvatarComponent
],
    templateUrl: './cerrix-selectable-user-list.component.html',
    styleUrl: './cerrix-selectable-user-list.component.scss',
    providers: [CerrixDialogService]
})
export class CerrixSelectableUserListComponent {
  @Input() public currentList!: UserListInterface;
  @Output() public currentListChange: EventEmitter<UserListInterface> =
    new EventEmitter();
  @Input() public users: UserModel[] = [];
  @Input() public editable: boolean = false;
  @Input() public dataUiid: string = "undefined"

  newUsers: UserModel[] = [];

  searchValue: string = '';

  private readonly _dialogService = inject(CerrixDialogService);

  filterUsers(userList: UserModel[]): UserModel[] {
    if (this.searchValue) {
      const regExp = new RegExp(this.searchValue, 'gmi');
      return userList.filter(
        x => x.firstName.match(regExp) || x.name.match(regExp)
      );
    }
    return userList;
  }

  toggleUser(user: UserModel) {
    if (this.editable) {
      if (!this.currentList.users.some(x => x === user.id)) {
        if (
          this.currentList.userLimit <= 0 ||
          (this.currentList.userLimit >= 0 &&
            this.currentList.users.length < this.currentList.userLimit)
        ) {
          this.currentList.messages = this.currentList.messages?.filter(
            message => message.error !== 'required'
          );
          this.currentList.users.push(user.id);
        } else {
          const currentUser = this.users.find(
            x => x.id === this.currentList.users[0]
          );
          this._dialogService.openDialog({
            data: {
              promptUiid: 'remove-assignee-uiid',
              title: `Unassign ${currentUser?.firstName} ${currentUser?.lastName} as reporter`,
              message:
                'When assigning a new user as reporter, the former reporter will be unassigned. Are you sure you want to continue this action?',
              icon: 'warning_amber',
              iconClass: 'warning',
              positiveButton: {
                text: 'Unassign user',
                buttonClass: 'warning',
                onAction: () => {
                  this.currentList.users[0] = user.id;
                  this.currentListChange.emit(this.currentList);
                  return true;
                },
              },
              negativeButton: {
                text: 'Cancel',
                buttonClass: 'cancel',
                onAction: () => {
                  return true;
                },
              },
            },
          });
        }
      } else {
        this.currentList.users.forEach((item, index) => {
          if (item === user.id) {
            this.currentList.users.splice(index, 1);
          }
        });
      }
    }
  }
}
